var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"container--fluid fill-height py-16 my-16"},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('h1',{staticClass:"error--text"},[_vm._v("403 Forbidden")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }